import * as apiFactory from "./ApiFactory";

import type { Filter } from "@/models/Filter";
import type FilterSet from "@/models/FilterSet";

export async function getAll(clientName: string, brand: string): Promise<FilterSet[]> {
  const client = await apiFactory.WithBearer();
  return await client.get<FilterSet[]>(["api/filterSet", clientName, brand]);
}
export async function save(clientName: string, brand: string, name: string, filters: Filter): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.post(["api/filterSet", clientName, brand, name], filters);
}
export async function promote(clientName: string, brand: string, name: string): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.put(["api/filterSet/promote", clientName, brand, name]);
}
export async function demote(clientName: string, brand: string, name: string): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.put(["api/filterSet/demote", clientName, brand, name]);
}

export async function deleteFilterSet(clientName: string, brand: string, name: string): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.delete(["api/filterSet", clientName, brand, name]);
}
